import { useEffect } from 'react'
import { Layers } from 'lucide-react'
import { useWindowManager } from '../WindowManager/WindowManagerContext'

interface Props { onClose: () => void }

export default function MissionControl({ onClose }: Props) {
  const { windows, focusWindow } = useWindowManager()

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') { e.preventDefault(); onClose() }
    }
    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [onClose])

  const handleClick = (id: string) => { focusWindow(id); onClose() }

  return (
    <div onClick={onClose} style={{
      position: 'fixed', inset: 0, zIndex: 99990,
      background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(12px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 40,
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
        gap: 16, width: '100%', maxWidth: 1200,
      }}>
        {windows.length === 0 && (
          <p style={{ color: 'var(--os-muted)', gridColumn: '1/-1', textAlign: 'center', fontSize: 14 }}>No open windows</p>
        )}
        {windows.map(win => {
          const Icon = win.icon || Layers
          return (
            <button key={win.id} onClick={() => handleClick(win.id)} style={{
              background: 'var(--os-surface)', border: '1px solid var(--os-border)',
              borderRadius: 12, padding: 20, cursor: 'pointer',
              display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10,
              transition: 'transform .15s, box-shadow .15s',
              boxShadow: 'var(--os-card-shadow)',
            }}
              onMouseEnter={e => { (e.currentTarget as HTMLElement).style.transform = 'scale(1.05)' }}
              onMouseLeave={e => { (e.currentTarget as HTMLElement).style.transform = 'scale(1)' }}
            >
              <Icon size={32} color={win.iconColor || 'var(--os-text)'} />
              <span style={{ color: 'var(--os-text)', fontSize: 12, fontWeight: 500, textAlign: 'center', wordBreak: 'break-word' }}>
                {win.title}
              </span>
            </button>
          )
        })}
      </div>
    </div>
  )
}
